import {
  SET_DAO_HO,
  SHOW_FORM_DAO_HO,
  POST_DAO_HO,
  POST_DAO_HO_SUCCESS,
  POST_DAO_HO_FAILURE,
  SET_CONFIG_DAO_HO,
  GET_CONFIG_SYS_DAO_HO,
} from './actionTypes';

export const setDaoHo = (dataEdit) => ({
  type: SET_DAO_HO,
  payload: dataEdit,
});

export const showFormDaoHo = (data) => {
  return {
    type: SHOW_FORM_DAO_HO,
    payload: data,
  };
};
export const postDaoHo = (dataPost) => ({
  type: POST_DAO_HO,
  dataPost,
});

export const postDaoHoSuccess = (data) => ({
  type: POST_DAO_HO_SUCCESS,
  payload: data,
});

export const postDaoHoFailure = () => ({
  type: POST_DAO_HO_FAILURE,
});

export const setConfig = (data) => ({
  type: SET_CONFIG_DAO_HO,
  payload: data,
});

export const getConfigSysDaoHo = (dataSearch) => ({
  type: GET_CONFIG_SYS_DAO_HO,
  dataSearch,
});
